import React from 'react';
import Icon from '../../../components/AppIcon';

const PlatformActivityChart = ({ activityData }) => {
  const maxValue = Math.max(
    ...activityData?.map(d => Math.max(d?.checkIns, d?.newUsers, d?.premiumSignups))
  );

  return (
    <div className="bg-card rounded-xl border border-border p-4 sm:p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-heading font-semibold text-foreground flex items-center gap-2">
          <Icon name="BarChart3" size={20} strokeWidth={2} />
          Platform Activity (Last 30 Days)
        </h2>
        <div className="flex items-center gap-4 text-xs">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-blue-500"></div>
            <span className="text-muted-foreground">Check-ins</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-green-500"></div>
            <span className="text-muted-foreground">New Users</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-purple-500"></div>
            <span className="text-muted-foreground">Premium</span>
          </div>
        </div>
      </div>

      <div className="overflow-x-auto">
        <div className="min-w-[600px] h-64 flex items-end gap-1">
          {activityData?.map((day, index) => (
            <div key={index} className="flex-1 flex flex-col items-center gap-1">
              <div className="w-full flex flex-col gap-0.5">
                <div
                  className="w-full bg-blue-500 rounded-t transition-all hover:bg-blue-600"
                  style={{ height: `${(day?.checkIns / maxValue) * 200}px` }}
                  title={`${day?.date}: ${day?.checkIns} check-ins`}
                ></div>
                <div
                  className="w-full bg-green-500 transition-all hover:bg-green-600"
                  style={{ height: `${(day?.newUsers / maxValue) * 200}px` }}
                  title={`${day?.date}: ${day?.newUsers} new users`}
                ></div>
                <div
                  className="w-full bg-purple-500 transition-all hover:bg-purple-600"
                  style={{ height: `${(day?.premiumSignups / maxValue) * 200}px` }}
                  title={`${day?.date}: ${day?.premiumSignups} premium signups`}
                ></div>
              </div>
              {index % 5 === 0 && (
                <span className="text-xs text-muted-foreground mt-2 whitespace-nowrap">
                  {day?.date}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlatformActivityChart;